var BaseViews = require('./base');
var CartLocationDisplay = require('./cart/cart-location-display');
require('./delivery-postal-code-form/delivery-postal-code-form.scss');
var DeliveryPostalCodeFormInput = require('./delivery-postal-code-form/delivery-postal-code-input');


var DeliveryPostalCodeFormSuccessState = BaseViews.LayoutView.extend({
  className: 'fmcy-delivery-postal-code-form-success-state',
  template: require('./delivery-postal-code-form/delivery-postal-code-form-success-state.html'),
  initialize: function(options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              postalCode: 'V0N 2M2',
              deliveryHoursMessage: null
          }
      );
  },
  serializeData: function () {
    return {
      postalCode: this.options.postalCode,
      deliveryHoursMessage: this.options.deliveryHoursMessage
    }
  }
});

var DeliveryPostalCodeForm = BaseViews.LayoutView.extend({
    className: 'fmcy-delivery-postal-code-form',
    template: require('./delivery-postal-code-form/delivery-postal-code-form.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                error: false,
                errorMessage: 'Please verify postal code.',
                changeToLocationModel: null,
                model: null,
                referrer: 'entry'
            }
        );
        if (this.options.model) {
          this.deliveryModel = this.options.model;
        } else {
          this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
        }
        
        // Listen for location change events
        this.listenTo(this.options._appChannel, 'after:location:changed', this._handleLocationChanged);
        
        // Track pending postal code to handle async location change
        this.pendingPostalCode = null;
    },
    _handleLocationChanged: function() {
        // If we have a pending postal code waiting for location change
        if (this.pendingPostalCode) {
            var postalCode = this.pendingPostalCode;
            this.pendingPostalCode = null; // Clear the pending state
            
            // Make sure any error state is cleared before showing success
            if (this.deliveryPostalCodeFormInput) {
                this.deliveryPostalCodeFormInput.toggleValidationAlert(false);
            }
            
            this._renderSuccessMessage(postalCode);
            this.trigger('show:continue:button');
        }
    },
    regions: {
      postalCodeFormRegion: '.fmcy-postal-code-form-region',
      deliverySuccessStateRegion: '.fmcy-delivery-success-state-region'
    },
    _hideSuccessMessage: function () {
      this.deliverySuccessStateRegion.empty();
    },
    _renderSuccessMessage: function (postalCode) {
      var self = this;
      var deliveryHoursMessage = null;
      
      var isDeliveryAvailableAtCurrentTime = this.options._appChannel.request('validate:is:delivery:available:at:this:time');

      if (isDeliveryAvailableAtCurrentTime && isDeliveryAvailableAtCurrentTime.deliveryAvailableAtThisTime) {
        deliveryHoursMessage = "The delivery hours are now open";
      } else if (isDeliveryAvailableAtCurrentTime && isDeliveryAvailableAtCurrentTime.deliveryNextAvailable) {
        if (isDeliveryAvailableAtCurrentTime.deliveryNextAvailable.isToday) {
          deliveryHoursMessage = "The delivery hours start today at " + isDeliveryAvailableAtCurrentTime.deliveryNextAvailable.startTime;
        } else {
          deliveryHoursMessage = "The delivery hours start on " + 
            isDeliveryAvailableAtCurrentTime.deliveryNextAvailable.day.charAt(0).toUpperCase() + 
            isDeliveryAvailableAtCurrentTime.deliveryNextAvailable.day.slice(1) + 
            " at " + isDeliveryAvailableAtCurrentTime.deliveryNextAvailable.startTime;
        }
      }

      var deliveryPostalCodeFormSuccessState = new DeliveryPostalCodeFormSuccessState({
        postalCode: postalCode,
        deliveryHoursMessage: deliveryHoursMessage
      });
      this.deliverySuccessStateRegion.show(deliveryPostalCodeFormSuccessState);
      this.trigger('show:continue:button');
    },
    _renderDeliveryPostalCodeFormInput: function (_options) {
      var self = this;
      var options = _.defaults(
          _options || {},
          {
              deliveryMethod: 'local_delivery',
              error: self.options.error,
              changeToLocationModel: self.options.changeToLocationModel,
              errorMessage: self.options.errorMessage
          }
      );

      this.deliveryPostalCodeFormInput = new DeliveryPostalCodeFormInput({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel.get('cartDeliveryAddressModel'),
        error: options.error,
        changeToLocationModel: options.changeToLocationModel,
        errorMessage: options.errorMessage,
        source: 'embedded'
      });

      this.deliveryPostalCodeFormInput.on('toggle:validation:alert', function (show) {
        if (show == true) {
          self._hideSuccessMessage();
        }
      });

      this.deliveryPostalCodeFormInput.on('validate:postal:code', function (postalCode) {
        self.options._appChannel.request('validate:postal:code:delivery:area', postalCode).then(function (result) {
            if (result.error == true) {
              self.deliveryPostalCodeFormInput.setAlertMessage('Sorry we cannot deliver to that postal code.');
              self.deliveryPostalCodeFormInput.toggleValidationAlert(true);
              self.trigger('hide:continue:button');
              self._hideSuccessMessage();
              if (self.deliveryPostalCodeFormInput) {
                self.deliveryPostalCodeFormInput.resetVerifyButton();
              }
            } else {
              if (self.deliveryPostalCodeFormInput) {
                self.deliveryPostalCodeFormInput.resetVerifyButton();
              }
              
              // Clear any previous error state
              self.deliveryPostalCodeFormInput.toggleValidationAlert(false);
              
              // First trigger location change if needed
              if (result.response && result.response.withinDeliveryAreaSlug) {
                // Store the postal code that's waiting for location change
                self.pendingPostalCode = postalCode;
                
                // Trigger the location change - success message will be shown after location changes
                self.options._appChannel.trigger('location:selected', result.response.withinDeliveryAreaSlug, self.options.referrer);
                
                // Fallback: If the location change event doesn't trigger within 2 seconds, show success anyway
                setTimeout(function() {
                  if (self.pendingPostalCode === postalCode) {
                    self.pendingPostalCode = null;
                    self._renderSuccessMessage(postalCode);
                    self.trigger('show:continue:button');
                  }
                }, 2000);
              } else {
                // No location change needed, just show success message
                self._renderSuccessMessage(postalCode);
                self.trigger('show:continue:button');
              }
            }
        });
      }); // end on validate:postal:code

      this.postalCodeFormRegion.show(this.deliveryPostalCodeFormInput);
    },
    _maybeRenderDeliveryPostalCodeFormSuccessState() {
      var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');

      if (currentSelectedLocationSlug == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_confirmed_farm_location_slug') &&
      this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') != null &&
      this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code')) {
        this._renderSuccessMessage(this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code'));
      }
    },
    onRender: function() {
      var self = this;

      this._renderDeliveryPostalCodeFormInput();
      this._maybeRenderDeliveryPostalCodeFormSuccessState();

      BaseViews.LayoutView.prototype.onRender.call(self);
    }
});

module.exports = DeliveryPostalCodeForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/delivery-postal-code-form.js
 **/